<template>
  <div class="user-menu__wrapper">
    <p class="user-menu__title subtitle-3">Your Account</p>

    <div class="user-menu__section-delimiter" />

    <a-link
      v-for="menuItem in menuItems"
      :key="menuItem.url"
      class="user-menu__menu-item text-primary-navigation"
      :to="generateIlUrl(menuItem.url)"
      :open-in-new-tab="false"
    >
      {{ menuItem.name }}
    </a-link>

    <div class="user-menu__section-delimiter" />

    <a-link
      class="user-menu__menu-item text-primary-navigation"
      to="contact-us"
      :open-in-new-tab="false"
    >
      Contact us
    </a-link>

    <div class="user-menu__section-delimiter" />

    <button
      class="user-menu__menu-item text-primary-navigation user-menu__logout-button"
      @click="logout"
    >
      Log out
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { GUARDED_ROUTES, ROUTE } from 'enums/routes'
import mixins from '@/utils/mixins'
import { USER_TYPE } from '@/utils/enums/users'

export default {
  name: 'AUserMenu',
  inheritAttrs: false,
  mixins: [mixins.urlGenerators],
  computed: {
    ...mapGetters({
      userDetails: 'auth/userDetails'
    }),
    menuItems() {
      return [
        {
          name: 'My Profile',
          url: ROUTE.PERSONAL_PROFILE
        },
        ...([
          USER_TYPE.SUBSCRIBER,
          USER_TYPE.FL_CONTRIBUTOR,
          USER_TYPE.FL_SPONSORED_CONTRIBUTOR
        ].includes(this.userDetails.Type)
          ? [
              {
                name: 'My Contributions',
                url: ROUTE.PERSONAL_PROFILE_MY_CONTRIBUTIONS
              }
            ]
          : []),
        {
          name: 'My Directory Listings',
          url: ROUTE.PERSONAL_PROFILE_MY_COMPANIES
        },
        {
          name: 'Following Preferences',
          url: ROUTE.PERSONAL_PROFILE_FOLLOWING_PREFERENCES
        }
      ]
    }
  },
  methods: {
    ...mapActions({
      deauthenticateUser: 'auth/deauthenticateUser'
    }),
    logout() {
      this.deauthenticateUser()
      if (GUARDED_ROUTES.includes(this.$route.name)) {
        this.$router.replace('/')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-menu__wrapper {
  color: $c--white;

  .user-menu__title {
    margin-bottom: 24px;
  }

  .user-menu__menu-item {
    display: block;
    margin: 24px 0;
    line-height: 20px;
    color: $c--white;
  }

  .user-menu__logout-button {
    height: 20px;
  }

  .user-menu__menu-item:hover {
    color: $c--main;
  }

  .user-menu__menu-item:first-child {
    margin-top: 0;
  }

  .user-menu__menu-item:last-child {
    margin-bottom: 0;
  }

  .user-menu__item-delimiter {
    display: none;

    @include mobile {
      display: block;
      height: 1px;
      background: $c--gray-dark;
    }
  }

  .user-menu__section-delimiter {
    height: 1px;
    margin: 10px 0;
    background: $c--gray-dark;
    content: '';
  }
}
</style>
